/* firmanumre-type.js - Alle / Mobil / Fastnet og underfiltre skifter uden genindlaesning.

   Toggles er almindelige links til Shopifys tag-filtrering (/collections/<handle>/mobil).
   Foer gav et klik en fuld sideindlaesning, som rullede til toppen og lod hele siden blinke.
   Nu hentes maalsiden i baggrunden (forudhentes ved hover og i ledig tid), og kun
   produktgitteret, toggle-raekken og underfiltrene byttes ud. Rulleposition, header og
   soegefelt staar stille. URL'en opdateres med history.replaceState (ikke pushState: temaet
   genindlaeser siden ved popstate, saa en pushState ville give en fuld indlaesning paa
   tilbage-knappen), saa deling og genindlaesning stadig rammer det valgte filter. Sortering og sidevisning foelger med, fordi det stadig er
   serverens egen HTML der vises. Kortenes klik bindes igen af firmanumre-kort.js'
   MutationObserver. */
(function () {
  var sektion = document.getElementById('CollectionSection');
  if (!sektion) return;
  var cache = {};
  var igang = null;

  function erToggle(a) { return a && a.matches('.fn-type__valg') && a.closest('#CollectionSection') && a.origin === location.origin; }

  function hent(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      ['catch'](function (e) { delete cache[url]; throw e; });
    return cache[url];
  }

  function byt(doc, url, push) {
    var nyGitter = doc.querySelector('#CollectionSection .grid--spacer');
    var gitter = sektion.querySelector('.grid--spacer');
    if (!nyGitter || !gitter) { location.href = url; return; }
    /* Layoutvagt: hvis den nye liste er kortere end den gamle, maa siden ikke hoppe, fordi
       browseren klemmer rullepositionen. Sektionen holder derfor mindst den hoejde, der
       skal til for at fylde viewporten fra den nuvaerende rulleposition. */
    var top = sektion.getBoundingClientRect().top + window.scrollY;
    var behov = Math.max(0, window.scrollY + window.innerHeight - top);
    sektion.style.minHeight = Math.min(sektion.offsetHeight, behov) + 'px';
    gitter.replaceWith(nyGitter);
    ['.fn-type', '.fn-underfiltre'].forEach(function (sel) {
      var gammel = sektion.querySelector(sel), ny = doc.querySelector('#CollectionSection ' + sel);
      if (gammel && ny) gammel.innerHTML = ny.innerHTML;
      else if (gammel && !ny) gammel.remove();
      else if (!gammel && ny) { var t = sektion.querySelector('.fn-type'); if (t) t.insertAdjacentElement('afterend', ny); }
    });
    if (doc.title) document.title = doc.title;
    if (push) history.replaceState(history.state, '', url);
    sektion.dispatchEvent(new CustomEvent('fn:gitter-byttet', { bubbles: true }));
  }

  function skift(url, push) {
    igang = url;
    sektion.classList.add('fn-type--henter');
    hent(url).then(function (doc) {
      if (igang !== url) return;
      byt(doc, url, push);
    })['catch'](function () { location.href = url; })
      .then(function () { sektion.classList.remove('fn-type--henter'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!erToggle(a) || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (a.href === location.href) return;
    skift(a.href, true);
  });
  /* Forudhentning: ved hover/touch paa et toggle, og i ledig tid for alle synlige toggles. */
  document.addEventListener('mouseover', function (e) { var a = e.target.closest('a'); if (erToggle(a) && a.href !== location.href) hent(a.href)['catch'](function () {}); });
  document.addEventListener('touchstart', function (e) { var a = e.target.closest('a'); if (erToggle(a) && a.href !== location.href) hent(a.href)['catch'](function () {}); }, { passive: true });
  function forudhent() {
    var links = sektion.querySelectorAll('.fn-type .fn-type__valg');
    for (var i = 0; i < links.length; i++) if (links[i].href !== location.href) hent(links[i].href)['catch'](function () {});
  }
  if ('requestIdleCallback' in window) window.requestIdleCallback(forudhent, { timeout: 3000 }); else window.setTimeout(forudhent, 1500);

})();
